import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

import { DataUtil } from '@celum/core';

// todo: this might have to be configurable... localization support!

export function isDate(c: AbstractControl): any {
  let validationResult = true;

  if (!DataUtil.isEmpty(c.value)) {
    validationResult = (c.value).match(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/);
  } else {
    validationResult = true;
  }

  return (validationResult) ? null : {
    isDate: {
      valid: false,
      messageKey: 'VALIDATION.IS_DATE',
      params: { format: 'yyyy/mm/dd' }
    }
  };
}

@Directive({
             selector: '[isDate][ngModel]',
             providers: [
               {
                 provide: NG_VALIDATORS,
                 useValue: isDate,
                 multi: true
               }
             ]
           })
export class DateValidator {

}
